import "aos/dist/aos.css";
import "swiper/swiper-bundle.css";
import "../css/styles.scss";
import AOS from "aos";
import "js-cloudimage-360-view/dist";
import {
  getCurrentPage,
  getBrowser,
  isMobile,
  byClass,
  byId,
  setStyle,
} from "./utils";
import {
  generateYearNumber,
  animateCelebrating,
  calcYearNumberPosition,
} from "./celebrating";
import { animateCraftVideo } from "./craft";
import { initWearImg, initSwiper } from "./wear";
import {
  bindPageDownClick,
  togglePageDownColor,
  toggleBackToTop,
} from "./pagedown";
import { animateWearImages } from "./wear-images";
import { randomRotateGifts } from "./gifts";
import { initCube, animateCubeVideo } from "./cubes";
import { handleMilestone } from "./milestone";
import { initYearsBar } from "./years-nav-bar";

function init() {
  window.scrollTo(0, 0);
  document.body.classList.add(getBrowser());
  window.addEventListener("scroll", onPageScroll);
  window.addEventListener("resize", onPageResize);
  bindPageDownClick();
  handleMilestone();
  generateYearNumber();
  initWearImg();
  randomRotateGifts();
  initThirdParty();
  initYearsBar();
}

/**
 * 如果是 IE 浏览器，需要等待 es6-shim 加载完成之后再加载主体
 */
function ieInit() {
  const timer = setInterval(() => {
    if (typeof Array.prototype.findIndex !== "undefined") {
      clearInterval(timer);
      init();
    }
  }, 100);
}

function initThirdParty() {
  AOS.init();
  initCube();
  initSwiper();
}

function onPageScroll() {
  animatePageSticky();
  animateCelebrating();
  animateCraftVideo();
  animateWearImages();
  animateCubeVideo();
  togglePageDownColor();
  toggleBackToTop();
}

function animatePageSticky() {
  // Only enable parallax scroll for page symbols.
  if (isMobile()) {
    if (
      [
        "yearbook",
        "symbols",
        "gifts",
        "wear-images",
        "wear-it-your-way",
      ].includes(getCurrentPage())
    ) {
      document.body.style.overflowX = "visible";
      byClass("page-container").style.overflowX = "visible";
    } else {
      document.body.style.overflowX = "auto";
      byClass("page-container").style.overflowX = "hidden";
    }
    setStyle(byId("yearbook"), {
      position: getCurrentPage() === "symbols" ? "fixed" : "sticky",
      top: getCurrentPage() === "symbols" ? 0 : "100vh",
    });
  }
}

function onPageResize() {
  switch (getCurrentPage()) {
    case "celebrating":
    case "yearbook":
      calcYearNumberPosition();
      animateCelebrating();
      break;
  }
  togglePageDownColor();
}

if (getBrowser() === "ie") {
  ieInit();
} else {
  init();
}
